<div>
  <span *ngIf="readonly && borderless">{{ value }}</span>
</div>
<input title="Value"
  *ngIf="!readonly || (readonly && !borderless)"
  nz-input
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  [readOnly]="readonly && !borderless"
  autocorrect="off"
  autocomplete="off"
  spellcheck="false"
  [disabled]="!this.isEnabled"
  [class]="readonly && !borderless ? 'bg-grey-lighter' : ''"
  [maxlength]="this.maxChar"
  [required]="this.isRequired"
  (click)="onClick($event.target)"
  (keydown)="onKeydown($event)"
  (keyup)="onKeyUp($event)"
  (paste)="onPaste($event)"
  class="width-100"
/>
